<template>
  <CCardBody>
    <CDataTable
        :items="items"
        :fields="fields"
        table-filter
        items-per-page-select
        :items-per-page="5"
        hover
        sorter
        pagination
    >

      <template #score="{item}">
        <td>
          <CProgress v-if="item.score"
                     :value="(item.score)*100"
                     :color = "item.color"
                     animated
                     show-value
                     style="height:20px;"
                     class="progress_bar"
          />
        </td>
      </template>

      <template #show_details="{item, index}">
        <td class="py-2">
          <CButton
              color="primary"
              variant="outline"
              square
              size="sm"
              @click="toggleDetails(item, index, items)"
          >
            {{Boolean(item._toggled) ? 'Hide' : 'Show'}}
          </CButton>
        </td>
      </template>

      <template #delete_user="{item}">
        <td class="py-2">
          <CButton
              color="danger"
              variant="outline"
              square
              size="sm"
              @click="deleteUser(item)"
          >
            Delete
          </CButton>
        </td>
        <slot></slot>
      </template>

      <template #export_user="{item}">
        <td class="py-2">
          <CButton
              color="primary"
              variant="outline"
              square
              size="sm"
              @click="exportUser(item)"
          >
            Export
          </CButton>
        </td>
        <slot></slot>
      </template>

      <template #details="{item}">
        <CCollapse class="grid-container" :show="Boolean(item._toggled)" :duration="collapseDuration">
          <slot></slot>
        </CCollapse>
      </template>
    </CDataTable>
  </CCardBody>
</template>

<script>
export default {
  props: {
    tableHeaders: Array,
    jsonData: Array,
    fromComponent: String
  },
  name: 'AdvancedTables',
  data () {
    return {
      details: [],
      collapseDuration: 0
    }
  },
  computed: {
    fields: function () {
      let columns = this.tableHeaders;
      let keyName = ''
      if (this.fromComponent === 'User') {
        keyName = 'delete_user'
      }
      else if(this.fromComponent === 'ExportUser') {
        keyName = 'export_user'
      }
      else {
        keyName = 'show_details'
      }
      columns.push({
        key: keyName,
        label: '',
        _style: 'width:1%',
        sorter: false,
        filter: false,
      })
      return columns
    },
    items: function () {
      return this.jsonData.map((item, id) => {
        return {
          ...item,
          id,
          dataID: item.id
        }
      });
    }
  },
  methods: {
    getBadge (status) {
      switch (status) {
        case 'Active': return 'success'
        case 'Inactive': return 'secondary'
        case 'Pending': return 'warning'
        case 'Banned': return 'danger'
        default: 'primary'
      }
    },
    toggleDetails (item, index, items) {
      this.$emit('clicked', items[item.id].category_id)
      this.$emit('viewQuestionClicked', items[item.id].dataID)
      this.$emit('showQue', items[item.id].dataID)
      this.$emit('toggle', !item._toggled)
      this.reset(this.items, item.id);
      this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0 })
    },
    reset(ids, current) {
      for(let i = 0; i < ids.length; i++) {
        if(i !== current)
          ids[i]._toggled = false;
      }
    },
    deleteUser (item) {
      this.$emit('delete', [item.dataID, item.name])
    },
    exportUser (item) {
      this.$emit('export', [item.company_id, item.company])
    }
  }
}
</script>

<style>

.grid-container {
  display: grid;
  grid-template-columns: 100%;
  background-color: #2196f3;
}

.progress_bar {
  /*margin-top: 3%;*/
  width: 50%;
}

</style>
